import { Flex, Grid, Heading, SystemStyleObject, Text } from '@chakra-ui/react';
import { AppLink, getClipPathBackground, getClipPathBorder, pxToRem } from '@cyberkongz/ui';

export type LinkData = { title: string; emphasis: string; href: string };

export type LinkStyle = {
  bgColor?: string;
  borderColor?: string;
  textColor?: string;
  textShadow?: string;
};

function LinkWithCuttedBorders({ linkData, linkSx }: { linkData: LinkData; linkSx?: LinkStyle }) {
  const { title, emphasis, href } = linkData;

  return (
    <Flex
      key={title}
      css={{
        alignItems: 'center',
        py: [5, 8],
        justifyContent: 'center',
        flexDirection: ['column', 'row'],
        position: 'relative',
        zIndex: 0,
        px: 5,
        '&:after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: -1,
          background: linkSx?.borderColor || 'text',
          clipPath: [getClipPathBorder(pxToRem(12)), getClipPathBorder(pxToRem(23))],
        },
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: -1,
          background: linkSx?.bgColor || 'transparent',
          clipPath: [getClipPathBackground(pxToRem(12)), getClipPathBackground(pxToRem(23))],
        },
      }}
    >
      <Text
        css={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
          mr: [0, 4],
          mb: [1, 0],
          fontSize: ['sm', 'lg'],
          letterSpacing: '0.03em',
          color: linkSx?.textColor || 'text',
        }}
      >
        {title}{' '}
      </Text>
      <AppLink href={href} variant="displayHover" css={{ color: linkSx?.textColor || undefined }}>
        <Heading
          variant="display"
          size="sm"
          letterSpacing="0.05em"
          color={linkSx?.textColor || undefined}
          textShadow={linkSx?.textShadow || undefined}
        >
          {emphasis}
        </Heading>
      </AppLink>
    </Flex>
  );
}

export function LinksWithCuttedBorders({
  links,
  stylesContainer,
  sxLink,
}: {
  links: LinkData[];
  stylesContainer?: SystemStyleObject;
  sxLink?: LinkStyle;
}) {
  return (
    <Grid gap={[6, 10]} css={{ maxWidth: pxToRem(590), mx: 'auto', ...stylesContainer }}>
      {links.map((link) => (
        <LinkWithCuttedBorders linkData={link} linkSx={sxLink} key={link.href} />
      ))}
    </Grid>
  );
}
